export { default } from '@material-ui/core/TableBody';
